import { ErrorHandler, Inject, Injectable, Injector, NgZone } from '@angular/core';
import { TranslateService } from '../translate/translate.service';
import { ConnectionService } from '../connection/connection.service';

@Injectable({
  providedIn: 'root'
})
export class IbexErrorService extends ErrorHandler {

  private lastError = null;
  private threshold = 1000 * 30; // log only once half a minute

  private acceptedMessages = ['Missing locale data', 'ExpressionChangedAfterItHasBeenCheckedError'];

  constructor(
    @Inject(Injector) private injector: Injector,
    private translate: TranslateService,
    private connectionService: ConnectionService
  ) {
    super();
  }

  handleError(err: any): void {
    const zone = this.injector.get(NgZone);

    if (err && err.message && this.checkMessage(err.message)) {
      let errParts = err.stack.split('\n');
      for (let part of errParts) {
        if (part.indexOf('ts') > -1 || part.indexOf('html') > -1) {
          console.info('acceptedError Message: ', err.message, part, zone);
          return;
        }
      }
      console.info('acceptedError Message: ', err, zone);
      return;
    }

    console.error('we now have an ibex-error, and we can handle it here');
    console.error(err);

    const now = Date.now();

    if (this.lastError && now - this.lastError < this.threshold) {
      return;
    }
    this.logerror(err);
    this.lastError = now;
  }

  checkMessage(message) {
    let isAccepted = false;
    this.acceptedMessages.map(accepted => {
      message = message.toLowerCase();
      if (message.indexOf(accepted.toLowerCase()) !== -1) {
        isAccepted = true;
      }
    });
    return isAccepted;
  }

  logerror(err) {
    console.log('error handled: ', window.location.href, err);

    const errorObject = {
      frontendType: 'ibextouch',
      destination: window['forcePackage'],
      route: window.location.href,
      userAgent: navigator.userAgent,
      errorType: err.name || err.message ? err.message.name : 'undefined',
      errorMessage: err.message,
      errorStack: err.stack,
    } as any;

    this.connectionService.create('/frontend-errors', errorObject).catch(apiErr => {
      console.log('error on error logging: ', apiErr);
    });
  }
}
